export * from './decoration-rooms-select.component';
